import { useContext } from 'react';

import { ThemeContext, type ThemeContextValue } from './themeContext';

export function useAppTheme(): ThemeContextValue {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error('useAppTheme must be used within <ThemeProvider>.');
  }

  return context;
}
